import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box } from '@mui/material';

interface MaintenanceProps {
  title: string;
  isVisible: boolean;
}

const Maintenance: React.FC<MaintenanceProps> = ({ title, isVisible }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Dialog
        open={isVisible}
        onClose={() => {}}
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ textAlign: 'center' }}>Maintenance</DialogTitle>
        <DialogContent>
          <Typography variant="body1" align="center" sx={{ pt: 2 }}>
            {title}
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Maintenance;
